export default class TimeStringHelper {
  static getTimeString(hours, minutes) {
    let timeString = hours != 0 ? hours + "h" : "";

    const minutesConverted = {
      0: "00",
      0.25: "15",
      0.5: "30",
      0.75: "45"
    };

    const minutesString = minutesConverted[minutes] || "00";

    return (timeString += minutes != 0 ? minutesString + "min" : "");
  }

  static convertFloatToTimeString(value) {
    const integer = Math.floor(value);
    const decimals = (value - integer).toFixed(2);
    return TimeStringHelper.getTimeString(integer, parseFloat(decimals));
  }
}
